import { render } from "./ReportPieChart.vue?vue&type=template&id=3c8bfa39&scoped=true"
import script from "./ReportPieChart.vue?vue&type=script&lang=js"
export * from "./ReportPieChart.vue?vue&type=script&lang=js"

import "./ReportPieChart.vue?vue&type=style&index=0&id=3c8bfa39&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8bfa39"]])

export default __exports__